// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1536":"d260d766","1835":"ea61c712","3798":"11819885","6433":"82020103","7022":"dfec99fa","8548":"ea61c712","9422":"2d7a771b","9641":"64a83a03"}[chunkId] + ".chunk.css";
};